$(".owl-carousel").each(function owlCarousel() {
  var $this = $(this);
  var numOfSlides = $this.attr("data-amount");
  var options = {
    "loop": ($this.attr("data-loop") === "true"),
    "dots": ($this.attr("data-dots") === "true"),
    "nav": ($this.attr("data-nav") === "true"),
    "mouseDrag": ($this.attr("data-mouse") === "true"),
    "number": 1,
    "navText": [
      "<span>&lt; prev</span>",
      "<span>next &gt;</span>"
    ]
  };

  if ($this.attr("data-single")) {
    options.items = 1;
  } else {
    options.responsive = {
      "0": {
        "items": 1,
        "margin": 20
      },
      "600": {
        "items": 2,
        "slideBy": 2,
        "margin": 30
      },
      "1000": {
        "items": (numOfSlides ? numOfSlides : 3),
        "slideBy": 3,
        "margin": 40
      }
    };
  }

  $this.owlCarousel(options);
});
